import React from 'react'
import { FormControl, InputLabel, OutlinedInput } from '@mui/material'

const CustomTextarea = ({ id, inputRef, label, width, minRows, value, onChange }) => {
  return (
    <FormControl className="formcontrol" variant="outlined" size="large" fullWidth={true}>
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <OutlinedInput id={id} inputRef={ inputRef } label={label} size="small" multiline minRows={minRows} value={value} type="text" onChange={onChange} style={{backgroundColor:'#fff'}} />
    </FormControl>
  );
}

export default CustomTextarea